var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "960" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-widget-settings")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-multi-select", {
                    attrs: {
                      label: _vm.$ct("select-local-calendar"),
                      grow: "",
                      items: _vm.calendarItems,
                      fancy: "",
                    },
                    model: {
                      value: _vm.selectedCalendars,
                      callback: function ($$v) {
                        _vm.selectedCalendars = $$v
                      },
                      expression: "selectedCalendars",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-multi-select", {
                    attrs: {
                      label: _vm.$ct("select-google-calendar"),
                      grow: "",
                      items: _vm.googleCalendarItems,
                      fancy: "",
                    },
                    model: {
                      value: _vm.selectedGoogleCalendars,
                      callback: function ($$v) {
                        _vm.selectedGoogleCalendars = $$v
                      },
                      expression: "selectedGoogleCalendars",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }